import { render } from "./ProdutoAbasInformativas.vue?vue&type=template&id=e598894e&ts=true"
import script from "./ProdutoAbasInformativas.vue?vue&type=script&lang=ts"
export * from "./ProdutoAbasInformativas.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__